const order = {
    state: {
        taobaoStatus: {},
        jingdongStatus: {},
        pinduoduoStatus: {},
        douyinStatus: {},
        distributionOrder: {}
    },
    getters: {},
    mutations: {
        SET_TAOBAO_STATUS (state, data) {
            let curStatus = JSON.stringify(state.taobaoStatus)
            curStatus = JSON.parse(curStatus)
            curStatus[data.sub_id] = data
            state.taobaoStatus = curStatus
        },
        SET_JINGDONG_STATUS (state, data) {
            let curStatus = JSON.stringify(state.jingdongStatus)
            curStatus = JSON.parse(curStatus)
            curStatus[data.sub_id] = data
            state.jingdongStatus = curStatus
        },
        SET_PINDUODUO_STATUS (state, data) {
            let curStatus = JSON.stringify(state.pinduoduoStatus)
            curStatus = JSON.parse(curStatus)
            curStatus[data.sub_id] = data
            state.pinduoduoStatus = curStatus
        },
        SET_DOUYIN_STATUS (state, data) {
            let curStatus = JSON.stringify(state.douyinStatus)
            curStatus = JSON.parse(curStatus)
            curStatus[data.sub_id] = data
            state.douyinStatus = curStatus
        },
        SET_DOU_YIN_ORDER (state, data) {
            let curStatus = JSON.stringify(state.distributionOrder)
            curStatus = JSON.parse(curStatus)
            curStatus[data.sub_id] = data
            state.distributionOrder = curStatus
        }
    },

    actions: {
        updateOrderDownloadStatus ({ commit, state }, { sub_id, data }) {
            const order_type = data.order_type
            const atpresent = data.atpresent
            let obj = {
                conduct: true,
                platform: order_type,
                progress: atpresent,
                sub_id: sub_id
            }
            if (order_type == 'taobao') {
                commit('SET_TAOBAO_STATUS', obj)
            }
            if (order_type == 'jingdong') {
                commit('SET_JINGDONG_STATUS', obj)
            }
            if (order_type == 'pinduoduo') {
                commit('SET_PINDUODUO_STATUS', obj)
            }
            if (order_type == 'douyin') {
                commit('SET_DOUYIN_STATUS', obj)
            }
            if (atpresent === 100) {
                setTimeout(() => {
                    obj.conduct = false
                    if (order_type == 'taobao') {
                        commit('SET_TAOBAO_STATUS', obj)
                    }
                    if (order_type == 'jingdong') {
                        commit('SET_JINGDONG_STATUS', obj)
                    }
                    if (order_type == 'pinduoduo') {
                        commit('SET_PINDUODUO_STATUS', obj)
                    }
                    if (order_type == 'douyin') {
                        commit('SET_DOUYIN_STATUS', obj)
                    }
                }, 1000);
            }
        }
    }
}

export default order
